import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';

import { allocateFulfillmentPlanFromShipmentDetails } from '../../../../store/inventory/inventory.actions';
import { directPrintPackingSlip, downloadPackingSlip, printPackingSlip } from '../../../../store/printing/print.actions';
import { usePrintSettings } from '../../core/hooks';
import { buildDefaultPrintSetting } from '../../../../containers/print-document-button-containers/core/buildDefaultPrintSetting';
import { DocumentType } from '../../../../enums/document-type';
import PrintDocumentMenuItem from '../../../../components/print-document-menu-item';

export const PackingSlip = ({ fulfillmentPlan, packingSlipTemplateId, userHasShippingRole }) => {
  const dispatch = useDispatch();
  const fulfillmentPlanId = fulfillmentPlan?.fulfillmentPlanId;
  const isDisabled = !userHasShippingRole;
  const hasPrintedPackingSlip = fulfillmentPlan.packingSlipPrintedStatus?.isPrinted ?? false;
  const printSettings = usePrintSettings(DocumentType.PackingSlip.printSettingKey);
  const onClick = useCallback(() => {
    dispatch(printPackingSlip([fulfillmentPlanId], hasPrintedPackingSlip, false, false));
  }, [dispatch, fulfillmentPlanId, hasPrintedPackingSlip]);
  const onDownload = useCallback(() => {
    dispatch(
      allocateFulfillmentPlanFromShipmentDetails(
        fulfillmentPlanId,
        downloadPackingSlip([fulfillmentPlanId], hasPrintedPackingSlip, packingSlipTemplateId, false),
      ),
    );
  }, [dispatch, fulfillmentPlanId, hasPrintedPackingSlip, packingSlipTemplateId]);
  const onPrint = useCallback(() => {
    dispatch(
      allocateFulfillmentPlanFromShipmentDetails(
        fulfillmentPlanId,
        directPrintPackingSlip([fulfillmentPlanId], hasPrintedPackingSlip, printSettings, packingSlipTemplateId, false),
      ),
    );
  }, [dispatch, fulfillmentPlanId, hasPrintedPackingSlip, packingSlipTemplateId, printSettings]);
  const defaultPrintSetting = useMemo(
    () => buildDefaultPrintSetting(printSettings, onPrint, onDownload),
    [onDownload, onPrint, printSettings],
  );

  return (
    <PrintDocumentMenuItem
      defaultPrintSetting={defaultPrintSetting}
      disabled={isDisabled}
      name={DocumentType.PackingSlip.documentNameTranslation}
      onClick={onClick}
    />
  );
};

PackingSlip.propTypes = {
  fulfillmentPlan: PropTypes.shape({
    fulfillmentPlanId: PropTypes.string.isRequired,
    packingSlipPrintedStatus: PropTypes.shape({
      isPrinted: PropTypes.bool,
    }),
  }).isRequired,
  packingSlipTemplateId: PropTypes.string.isRequired,
  userHasShippingRole: PropTypes.bool.isRequired,
};
